export enum GetManyVendorsStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}
